// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".message-block[data-v-1c93396d]{padding:5px;margin:4px 0}.message-content[data-v-1c93396d],.message-new[data-v-1c93396d]{font-size:xx-small}.message-new[data-v-1c93396d]{float:right;color:#fa8b59}.message-button-active[data-v-1c93396d]{color:#fff;background-color:#4285f4}.message-button[data-v-1c93396d],.message-button-active[data-v-1c93396d]{width:40px;height:20px;text-align:center;padding-top:2px;cursor:pointer}", ""]);
// Exports
module.exports = exports;
